import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";
import { FaPlus, FaTrash } from "react-icons/fa";
import { usePermissions } from "../../context/PermissionContext";
import AccessDenied from "../ui/AccessDenied";

const PurchaseBillList = () => {
  const { canView, canCreate, canDelete } = usePermissions();
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);

  if (!canView("purchase_bills")) {
    return <AccessDenied moduleName="Purchase Bills" action="view" />;
  }

  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const res = await api.get("purchase_bills/");
      setBills(res.data);
    } catch (err) {
      console.error("Error fetching purchase bills:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!canDelete("purchase_bills")) {
      alert("Access Denied: You do not have permission to delete purchase bills.");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this purchase bill?")) return;
    try {
      await api.delete(`purchase_bills/${id}`);
      setBills(bills.filter((b) => b.id !== id));
    } catch (err) {
      console.error("Error deleting purchase bill:", err);
      alert("Failed to delete purchase bill.");
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Purchase Bills</h3>
        {canCreate("purchase_bills") && (
          <Link to="/dashboard/transactions/purchase-bills/new" className="btn btn-primary d-flex align-items-center gap-2">
            <FaPlus /> Add Purchase Bill
          </Link>
        )}
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>Bill #</th>
                  <th>Date</th>
                  <th>Supplier</th>
                  <th>Method</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">Loading purchase bills...</td>
                  </tr>
                ) : bills.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-muted">No purchase bills found.</td>
                  </tr>
                ) : (
                  bills.map((b) => (
                    <tr key={b.id}>
                      <td>{b.bill_number}</td>
                      <td>{new Date(b.bill_date).toLocaleDateString()}</td>
                      <td>{b.supplier_name || `Supplier #${b.supplier_id}`}</td>
                      <td>{b.payment_method}</td>
                      <td className="fw-bold text-success">${Number(b.amount).toFixed(2)}</td>
                      <td>
                        <span className={`badge bg-${b.status === 'Paid' ? 'success' : 'warning'}`}>
                          {b.status}
                        </span>
                      </td>
                      <td className="text-end">
                        {canDelete("purchase_bills") ? (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(b.id)}
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                        ) : (
                          <span title="No delete permission" style={{ color: "#cbd5e1", fontSize: "18px", cursor: "not-allowed" }}>🔒</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseBillList;
